module.exports = __webpack_public_path__ + "static/mask-e9d2c42308b5aab54f6483462f47d631.png";